import { IconTriangle } from "../TriangleIcon";
import { cn } from "@/core/helpers/cn";

export function ElevatorBusinessDirectionDisplay({
  direction,
  isActive,
}: {
  direction: "up" | "down";
  isActive: boolean;
}) {
  return (
    <div className="contents">
      <IconTriangle
        className={cn(
          "relative transition-all duration-800",
          direction === "down" && "rotate-180",
          isActive
            ? "visible text-[#ff4e4e] translate-y-[0px]"
            : "visible text-[#3f3f3f] translate-y-[11px]",
        )}
      />
      <IconTriangle
        className={cn(
          "relative -top-[13px]",
          direction === "down" && "rotate-180",
          isActive && "text-[#6f2828]",
        )}
      />
      <IconTriangle
        className={cn(
          "relative transition-all duration-800",
          direction === "down" && "rotate-180",
          isActive
            ? "visible text-[#3f1c1c] -translate-y-[26px]"
            : "visible text-[#3f3f3f] -translate-y-[37px]",
        )}
      />
    </div>
  );
}
